import { EventType, FeedProvider } from "../commons/Constants";
import postEvent, { createBaseLanderEvent } from "../commons/LanderEvent";
import { Settings } from "../config";

export { EventType };

export interface RollerAdsEventOptions {
  bid?: number;
  campaignId?: number;
  adUrl?: string;
  errorCode?: string;
  keyword?: string;
  isBackfill?: boolean;
  /** RollerAds account (pid) the event's request went to: 309, 343 or 387. */
  pid?: string;
  /**
   * PARKING-5307: whether the keyword list shown to the visitor came from the
   * API's LLM keywords. Pass it only where that is known (the 1-click flow's
   * KEYWORD_CLICK, AD_REDIRECT, and the ERROR events a keyword click leads to);
   * leave it out everywhere else, and the event carries no such field. Sent as
   * true/false (false is kept) and only while LLM_KEYWORDS_ENABLED is on.
   */
  llmKeywordsUsed?: boolean;
}

export function sendRollerAdsEvent(
  eventType: string,
  landerConfig: any,
  options?: RollerAdsEventOptions
) {
  const event = createBaseLanderEvent(eventType, landerConfig);
  event.feedProvider = FeedProvider.ROLLER_ADS;

  if (options?.bid != null) {
    event.rollerAdsBid = options.bid;
  }
  if (options?.campaignId != null) {
    event.rollerAdsCampaignId = options.campaignId;
  }
  if (options?.adUrl) {
    event.rollerAdsUrl = options.adUrl;
  }
  if (options?.errorCode) {
    event.errorCode = options.errorCode;
  }
  if (options?.keyword) {
    event.rollerAdsKeyword = options.keyword;
  }
  if (options?.isBackfill) {
    event.isBackfill = true;
  }
  if (options?.pid) {
    event.rollerAdsPid = options.pid;
  }
  if (
    Settings.LLM_KEYWORDS_ENABLED &&
    typeof options?.llmKeywordsUsed === "boolean"
  ) {
    event.llmKeywordsUsed = options.llmKeywordsUsed;
  }
  // For AD_REDIRECT, use sendBeacon to ensure delivery before page unload
  if (eventType === EventType.AD_REDIRECT) {
    const endpoint = Settings.EVENT_PUBLISH_API;
    const blob = new Blob([JSON.stringify(event)], {
      type: "application/json",
    });
    navigator.sendBeacon(endpoint, blob);
    return;
  }

  postEvent(Settings.EVENT_PUBLISH_API, event);
}
